import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      setTimeout(
        () =>
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen }),
        4000
      );
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  markAllMessagesRead: async ({ commit }, { params, conversationIds = [] }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen },
      } = await ConversationApi.markAllRead(params);

      commit(mutationTypes.MARK_CONVERSATIONS_READ, {
        conversationIds,
        lastSeen,
      });

      return { lastSeen };
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  resolveAllMineConversations: async ({ commit }, { params }) => {
    try {
      const {
        data: { affected_count: affectedCount },
      } = await ConversationApi.resolveAll(params);

      commit(mutationTypes.MARK_CONVERSATIONS_RESOLVED);

      return { affectedCount };
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
